/**
 * @generated SignedSource<<284b9c1edcf6c9b522be687eeef22ad2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type webFormEditorUtils_getFormStateFromRevisionFragment$data = {
  readonly questions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly answerKey: {
          readonly correctIds: ReadonlyArray<string>;
          readonly feedback: string | null;
        } | null;
        readonly id: string;
        readonly isRequired: boolean;
        readonly options: ReadonlyArray<{
          readonly id: string;
          readonly label: string;
        }> | null;
        readonly ordering: number;
        readonly richEditorBody: string;
        readonly type: WebFormQuestionType;
      };
    }>;
  };
  readonly webFormId: string;
  readonly " $fragmentType": "webFormEditorUtils_getFormStateFromRevisionFragment";
};
export type webFormEditorUtils_getFormStateFromRevisionFragment$key = {
  readonly " $data"?: webFormEditorUtils_getFormStateFromRevisionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"webFormEditorUtils_getFormStateFromRevisionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "webFormEditorUtils_getFormStateFromRevisionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webFormId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormQuestionNodeConnection",
      "kind": "LinkedField",
      "name": "questions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WebFormQuestionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormQuestion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ordering",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "richEditorBody",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isRequired",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WebFormQuestionOption",
                  "kind": "LinkedField",
                  "name": "options",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "label",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WebFormQuestionAnswerKey",
                  "kind": "LinkedField",
                  "name": "answerKey",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "correctIds",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "feedback",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebFormRevision",
  "abstractKey": null
};
})();

(node as any).hash = "704bca5a074ba0c371c92fa42dd4ea19";

export default node;
